import React from 'react'
import { useGlobalContext } from '../../context';
import { durationOfTravel, humanizeDate, humanizeTime } from '../../utils/helpers';
import './TripListCard.css';
import Loading from '../loading/Loading';

function TripListCard({trip}) {
  const {sendReservation, journeySelected, setTrip, isLoadingReservation, booked} = useGlobalContext();
  const {id, departureStop, departureTime, arrivalStop, arrivalTime} = trip

  const isJourneySelectedEmpty = Object.keys(journeySelected).length === 0
  const isBookingSuccessful = booked === journeySelected && !isLoadingReservation
  const isTripReadyForBooking = !isBookingSuccessful && !isJourneySelectedEmpty

  return (
    <article key={id} className='trip-list-card' onClick={() => setTrip(trip)}>
      <p><small>Day of travel : {humanizeDate(departureTime)}</small></p>
      <h5>Leaves : {departureStop} at {humanizeTime(departureTime)} - arrives : {arrivalStop} at {humanizeTime(arrivalTime)}</h5>
      <p><small>Duration : {durationOfTravel(departureTime, arrivalTime)} minutes</small></p>
      {isLoadingReservation && trip === journeySelected && <Loading/>}
      {isTripReadyForBooking && trip === journeySelected && <button onClick={() => sendReservation(journeySelected)}>reserve</button>}
      {isBookingSuccessful && trip === journeySelected && <p>Great, that has been booked!</p>}
      <hr/>
    </article>
  )
}

export default TripListCard
